// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var Password = function (x) {
    return x;
};
var tsBridgePassword = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("Password")("__brandPassword"));
    }
};
var writePassword = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPassword = Data_Show.showString;
var readPassword = Simple_JSON.readString;
var ordPassword = Data_Ord.ordString;
var newtypePassword = {
    Coercible0: function () {
        return undefined;
    }
};
var makePassword = Password;
var eqPassword = Data_Eq.eqString;
export {
    Password,
    makePassword,
    unwrap,
    newtypePassword,
    eqPassword,
    ordPassword,
    showPassword,
    readPassword,
    writePassword,
    tsBridgePassword
};
//# sourceMappingURL=index.js.map
